// src/api/purchaseOrderApi.ts

import { ENV } from '../../config/runtimeEnv';
const API_BASE_URL = ENV.VITE_COMMERCE_SERVER;

import type { PurchaseOrder } from '../../types/inventory/OrderTypes';
import { http } from "../../lib/http/client";

export const fetchPurchaseOrders = async (params?: any): Promise<{ data: PurchaseOrder[]; total: number }> => {
    const response = await http.get(`${API_BASE_URL}/purchase-orders`, {
        params,
    });
    return { data: response.data.data, total: response.data.total };
};

export const fetchPurchaseOrder = async (id: number): Promise<PurchaseOrder> => {
    const response = await http.get(`${API_BASE_URL}/purchase-orders/${id}`);
    return response.data;
};

export const createPurchaseOrder = async (orderData: PurchaseOrder): Promise<PurchaseOrder> => {
    const response = await http.post(`${API_BASE_URL}/purchase-orders`, orderData);
    return response.data;
};

export const updatePurchaseOrder = async (id: number, orderData: Partial<PurchaseOrder>): Promise<PurchaseOrder> => {
    const response = await http.put(`${API_BASE_URL}/purchase-orders/${id}`, orderData);
    return response.data;
};

export const deletePurchaseOrder = async (id: number): Promise<void> => {
    await http.delete(`${API_BASE_URL}/purchase-orders/${id}`);
};
